import { Poppins, Quicksand } from 'next/font/google'
import React, { useState } from 'react'
import { FaChevronDown } from "react-icons/fa";
import EnrollForm from './enroll-form';
const popins = Poppins({weight:['400','500','600','700'],subsets:['latin'],display:'swap',preload:true})
const quickSand = Quicksand({weight:['400','500','600','700'],subsets:['latin'],display:'swap',preload:true})

export default function CourseSyllabus({syllabusData,title,SectionRef,location1}) {
    const [activeIndex,setActiveIndex] = useState(null);

        // Initialize arrowRotation with an array of false values
  const handleAccordionClick = (index) => {
  setActiveIndex((prevIndex) => (prevIndex === index ? null : index));

  };

  return (
   <>
   <section className={`container`} ref={SectionRef}>
    <div className='whole-pdtb'>
   <h2 className={`fs-30 tfs-28 mfs-21 fwb600 ${popins.className}`}><span className={`ylw-clr  ${popins.className}`}> Detailed {title}  </span> Course Syllabus  </h2>
    <div className={`df fjsb syllabus-tdf`}>
        <div className='w55p mw100p syllabus-box mt32 tmt28 mmt24'>
            {syllabusData.map((items,index)=>{
                return(
            <div key={index} className={``} onClick={() => handleAccordionClick(index)}>
                <div className={`df fjsb fjc fac cursor pdtlr24`}>
                <h3 className={`fs-16 mfs-15 fwb500 ${popins.className}`}>{items.title}</h3>
                <div className={`${index === activeIndex ? 'rotate-arrow' : 'rotate-normal'} fac`}  onClick={(e) => {
                            e.stopPropagation();
                            handleAccordionClick(index);
                            }}>
                <FaChevronDown  className='fs-20 tfs-18 mfs-16 '/>
                </div>
                </div>
                {index === activeIndex &&(
                    <ul style={{padding:'10px 10px 0px 10px'}}>
                        {items.cnt.map((subItem,subIndex)=>{
                            return(
                       <h4  key={subIndex} style={{ marginLeft: '20px', position: 'relative', paddingLeft: '15px' }} className={`fs-16 custom-h4 mfs-15 pdt10 fwb500 ${quickSand.className}`}>{subItem}</h4> 
                    )})}
                    </ul>
                )}
                <div className={`syllabus-line mt20`}></div>
            </div>
            
        )
    })}
        </div>
         {/* Sticky Form */}
         <div className="enroll-form-sticky mt32">
            {/* //<EnrollForm course={`${title} ${location1}`}/> */}
            <EnrollForm course={`${title} ${location1 ? `${location1}` : ' '}`} />

          </div>
    </div>
    </div>
   </section>
   </>
  )
}
